/**
 * A utility class to handle json related operation.
 *
 * Todo: migrate flatten from JsonFlattener class to this class: https://sim.amazon.com/issues/caracara-52183
 */
export class JsonUtil {
    /**
     * Takes in an input object, processes it, and then stringifies it using JSON.stringify.
     * It does NOT support additional arguments to pass to JSON.stringify (replacer and/or space)
     * @param obj The value to convert to a JSON string
     * @param additionalInfo Additional info to be logged in case of failure
     * @returns A JSON string representing the given value
     */
    static safeStringify(obj, additionalInfo) {
        var _a;
        try {
            return {
                result: obj === undefined || obj === null
                    ? JSON.stringify({
                        safeStringifyMessage: 'Undefined or null object',
                    })
                    : JSON.stringify(obj),
                failed: false,
            };
        }
        catch (e) {
            let stringifySafeReturnObj = {
                safeStringifyMessage: 'Safely caught JSON.stringify error.',
            };
            if (e instanceof Error) {
                stringifySafeReturnObj = Object.assign(Object.assign({}, stringifySafeReturnObj), { safeStringifyErrorMessage: e.message, safeStringifyErrorStack: (_a = e.stack) !== null && _a !== void 0 ? _a : 'No error stack present' });
            }
            if (additionalInfo && typeof additionalInfo === 'string') {
                stringifySafeReturnObj = Object.assign(Object.assign({}, stringifySafeReturnObj), { safeStringifyAdditionalInfo: additionalInfo });
            }
            console.warn(stringifySafeReturnObj);
            return {
                result: JSON.stringify(stringifySafeReturnObj),
                failed: true,
            };
        }
    }
}
//# sourceMappingURL=JsonUtil.js.map